/**
 * 0-%-MwSt-Befreiung (§ 12 Abs. 3 UStG) - gesamte Client-Logik.
 *
 * WARUM ES DIESE DATEI GIBT
 * Bis 01.09.2026 lag diese Logik als <script> in den Snippets selbst. Der
 * Cart-Drawer ersetzt bei JEDER Warenkorb-Aenderung die Kinder seines Footers
 * durch frisch geparstes HTML (assets/theme.js, CartDrawer._onCartChanged ->
 * footerEl.replaceChildren(...)). Ueber DOMParser bzw. innerHTML erzeugte
 * <script>-Elemente fuehrt der Browser nie aus. Ab dem zweiten Artikel im
 * Warenkorb war die Checkbox deshalb tot: anklickbar, aber ohne Listener.
 * "Zur Kasse" loeste dann den normalen Checkout mit voller Steuer aus, und
 * beim Server kam nichts an, weshalb im Audit-Log auch nichts stand.
 *
 * Deshalb: EINMAL im Layout geladen, alles ueber Delegation am `document`.
 * Das document wird nie ersetzt, also kann kein Re-Render die Strecke mehr
 * abhaengen - egal welches Snippet spaeter dazukommt.
 *
 * ZWEITE SAEULE: die Erklaerung lebt im Warenkorb-Attribut, nicht im DOM.
 * Ein Haekchen im DOM ist nach jedem Seitenwechsel weg, ohne dass der Kunde
 * es merkt - der Warenkorb zeigt dann wieder Bruttopreise. Als
 * Warenkorb-Attribut ueberlebt die Erklaerung Seitenwechsel, Re-Render und
 * Geraetewechsel, ist im Shopify-Admin an der Bestellung sichtbar und dient
 * dem Server-Guard als Beweis, dass der Kunde erklaert hat. Faellt die
 * Strecke doch einmal aus, traegt die besteuerte Bestellung das Attribut und
 * der Guard meldet sie, statt dass es erst dem Kunden auffaellt.
 */
(function () {
  'use strict';

  /* Sichtbarer Name: das Attribut taucht im Admin an der Bestellung auf und
     soll dort ohne Erklaerung lesbar sein. Attribute mit _ waeren versteckt. */
  var ATTRIBUTE_NAME = 'MwSt-Befreiung';
  var ATTRIBUTE_VALUE = 'Betreibererklärung akzeptiert';

  var declared = false;
  var inFlight = false;
  /* Sobald der Kunde selbst getippt hat, ist SEINE Entscheidung fuehrend.
     Ohne das koennte ein Re-Render mit noch nicht aktualisiertem HTML ein
     gerade abgewaehltes Haekchen wieder setzen. */
  var userDecided = false;

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function blocks() {
    return document.querySelectorAll('[data-mwst-root]');
  }

  function endpoint() {
    var el = document.querySelector('[data-mwst-endpoint]');
    return el ? el.getAttribute('data-mwst-endpoint') : null;
  }

  function countryCode() {
    var el = document.querySelector('[data-mwst-country]');
    return el ? el.getAttribute('data-mwst-country') : 'DE';
  }

  /**
   * E-Mail des angemeldeten Kunden, sonst null. Ohne sie entsteht die
   * Draft-Order anonym: niemand kann nachfassen, wenn der Kunde den
   * Rechnungslink nicht bezahlt.
   */
  function customerEmail() {
    var el = document.querySelector('[data-mwst-email]');
    if (!el) return null;
    var value = el.getAttribute('data-mwst-email') || '';
    // 06.10.2026: E-Mail als JSON im Script-Tag (nicht in Replays sichtbar).
    if (!value && el.tagName === 'SCRIPT') {
      try {
        var parsed = JSON.parse(el.textContent || 'null');
        value = typeof parsed === 'string' ? parsed : '';
      } catch (e) {
        value = '';
      }
    }
    return value ? value : null;
  }

  /* Telefonnummer aus den Theme-Einstellungen (b2b_contact_phone, I25), damit
     "rufen Sie uns an" eine Nummer traegt. Fehlt das Attribut, bleibt der
     Satz wie bisher ohne Nummer. */
  function callUs() {
    var el = document.querySelector('[data-mwst-phone]');
    var phone = el ? el.getAttribute('data-mwst-phone') : '';
    return phone ? 'rufen Sie uns an: ' + phone + '.' : 'rufen Sie uns an.';
  }

  function setError(message) {
    var nodes = document.querySelectorAll('[data-mwst-error]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = message || '';
  }

  /**
   * Express-Buttons (PayPal, Apple Pay) umgehen den Warenkorb komplett und
   * wuerden mit voller Steuer abrechnen. Bei gesetzter Erklaerung ausblenden,
   * sonst fuehrt der bequemste Weg am Steuervorteil vorbei.
   */
  function toggleExpress(hide) {
    var wraps = document.querySelectorAll('.additional-checkout-buttons');
    for (var i = 0; i < wraps.length; i++) {
      var el = wraps[i];
      if (hide) {
        /* Nur merken, was wir selbst verstecken. Sonst wuerden wir beim
           Zuruecknehmen Buttons einblenden, die aus einem anderen Grund
           ausgeblendet waren (Produktseite bei ausverkaufter Variante). */
        if (!el.hidden) {
          el.hidden = true;
          el.setAttribute('data-mwst-hid', '1');
        }
      } else if (el.getAttribute('data-mwst-hid') === '1') {
        el.hidden = false;
        el.removeAttribute('data-mwst-hid');
      }
    }
  }

  /** Alle Instanzen (Warenkorb-Seite UND Drawer) auf den Stand bringen. */
  function syncUi() {
    var list = blocks();
    for (var i = 0; i < list.length; i++) {
      var root = list[i];
      var box = root.querySelector('[data-mwst-checkbox]');
      if (box) box.checked = declared;
      root.classList.toggle('mwst--active', declared);
      var confirm = root.querySelector('[data-mwst-confirm]');
      if (confirm) confirm.hidden = !declared;
    }
    toggleExpress(declared && list.length > 0);

    /* Die Gesamtsumme spiegelt den Zustand: mit Erklaerung wird der
       Nettobetrag zur Hauptzahl. Beide Flaechen tragen data-vat-rate,
       Drawer und Warenkorb-Seite bleiben damit gleich. */
    var totals = document.querySelectorAll('[data-vat-rate] .price-tax-breakdown');
    for (var t = 0; t < totals.length; t++) {
      totals[t].classList.toggle('price-tax-breakdown--invert', declared && list.length > 0);
    }
  }

  /**
   * Erklaerung im Warenkorb sichern. Der In-Memory-Zustand ist bewusst SOFORT
   * gesetzt, bevor der Request laeuft: wer das Haekchen setzt und sofort auf
   * "Zur Kasse" klickt, darf nicht in ein Rennen zwischen Klick und Speichern
   * geraten.
   */
  function persist(value) {
    var body = { attributes: {} };
    body.attributes[ATTRIBUTE_NAME] = value ? ATTRIBUTE_VALUE : '';
    return fetch(shopRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {
      /* Ohne Attribut funktioniert der Kauf weiter, nur die Wiederherstellung
         nach einem Seitenwechsel faellt aus. Kein Grund, den Kunden zu
         blockieren. */
    });
  }

  function cartJson() {
    return fetch(shopRoot() + 'cart.js').then(function (r) { return r.json(); });
  }

  function submitExempt(button) {
    if (inFlight) return;
    var url = endpoint();
    if (!url) return;

    inFlight = true;
    var previousBusy = button.getAttribute('aria-busy');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    function reset() {
      inFlight = false;
      button.disabled = false;
      if (previousBusy === null) button.removeAttribute('aria-busy');
      else button.setAttribute('aria-busy', previousBusy);
    }

    cartJson()
      .then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        var keys = ['gclid', 'gbraid', 'wbraid', '_denk_consent_ad_user_data', '_denk_consent_ad_personalization', '_denk_id', '_denk_lead'];
        var attribution = {};
        keys.forEach(function (k) { if (attrs[k]) attribution[k] = attrs[k]; });

        var lineItems = (cart.items || []).map(function (item) {
          return {
            variant_id: item.variant_id,
            product_id: item.product_id,
            price: (item.final_price / 100).toFixed(2),
            title: item.title,
            quantity: item.quantity
          };
        });

        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            lineItems: lineItems,
            countryCode: countryCode(),
            customerDeclaration: true,
            customerEmail: customerEmail(),
            denkAttribution: attribution
          })
        });
      })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        var message = result.data && result.data.message;
        if (message && message.indexOf('incompatible') !== -1) {
          setError(message.substring(message.indexOf('-') + 1));
        } else if (result.ok && message) {
          window.location.href = message;
          return;
        } else {
          setError('Die steuerfreie Bestellung konnte nicht erstellt werden. Bitte versuchen Sie es erneut oder ' + callUs());
        }
        reset();
      })
      .catch(function () {
        setError('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder ' + callUs());
        reset();
      });
  }

  /* ---------------------------------------------------------------- Events */

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('[data-mwst-checkbox]')) return;
    declared = !!target.checked;
    userDecided = true;
    setError('');
    syncUi();
    persist(declared);
  });

  /**
   * Capture-Phase: laeuft vor den Theme-Handlern, ohne den Button zu ersetzen
   * oder zu klonen. name="checkout" bleibt unangetastet, daran haengt das
   * Attributions-Tracking (assets/denk-cart-attribution.js).
   *
   * Fuer Haendler (B2B) laeuft dieser Pfad nie: der Baustein wird fuer sie gar
   * nicht gerendert, die Kasse uebernimmt assets/b2b-checkout.js (Schritt T4).
   * Der Guard ist trotzdem da, damit ein Zustand aus einer frueheren Sitzung
   * (persistierte Erklaerung) den B2B-Checkout nicht abfangen kann.
   */
  document.addEventListener('click', function (event) {
    if (window.__b2bCtx && window.__b2bCtx.isB2B) return;
    if (!declared) return;

    var node = event.target;
    if (node && node.nodeType !== 1) node = node.parentElement;
    if (!node || !node.closest) return;
    var button = node.closest('button[name="checkout"], input[name="checkout"]');
    if (!button) return;

    /* Nur eingreifen, wenn auf dieser Seite ueberhaupt ein Baustein steht.
       Sonst waere der Zustand aus einem anderen Marktkontext uebrig. */
    if (!blocks().length) return;

    event.preventDefault();
    event.stopPropagation();
    setError('');
    submitExempt(button);
  }, true);

  /** Umschaltangebot "Auf Deutschland umstellen" - ebenfalls delegiert. */
  document.addEventListener('click', function (event) {
    var node = event.target;
    if (node && node.nodeType !== 1) node = node.parentElement;
    if (!node || !node.closest) return;
    var button = node.closest('[data-mwst-switch-de]');
    if (!button || button.disabled) return;

    button.disabled = true;
    var body = new URLSearchParams();
    body.set('form_type', 'localization');
    body.set('_method', 'put');
    body.set('country_code', 'DE');
    body.set('return_to', window.location.pathname + window.location.search);

    fetch(shopRoot() + 'localization', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    })
      .then(function () { window.location.reload(); })
      .catch(function () { button.disabled = false; });
  });

  /* ------------------------------------------------------------ Lebenslauf */

  /**
   * Der Zustand kommt beim ersten Aufbau aus dem Warenkorb-Attribut, das
   * Liquid in `data-mwst-declared` schreibt. Nach einem Re-Render ist der
   * In-Memory-Zustand fuehrend: er kann dem gerade gespeicherten Attribut
   * voraus sein.
   */
  function adopt() {
    if (!userDecided) {
      var first = document.querySelector('[data-mwst-root]');
      if (first && first.getAttribute('data-mwst-declared') === '1') declared = true;
    }
    syncUi();
  }

  function schedule() {
    setTimeout(adopt, 0);
    setTimeout(adopt, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', adopt);
  } else {
    adopt();
  }

  /* Der Drawer baut seinen Footer bei diesen Ereignissen neu auf. */
  document.addEventListener('cart:change', schedule);
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('variant:add', schedule);
})();
